var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "141px",
    viewBox: "0 0 146 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dribbble-ball-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.5,2.29368993e-15 C52.6390574,-3.44053489e-15 26,26.6390574 26,59.5 C26,92.3609426 52.6390574,119 85.5,119 C118.360943,119 145,92.3609426 145,59.5 C144.964417,26.6538074 118.346193,0.035582517 85.5,2.29368993e-15 Z M124.882595,27.4386936 C132.207875,36.364294 136.258583,47.5276627 136.361654,59.0738932 C134.683051,58.7188043 117.884115,55.3099501 100.975423,57.4404839 C100.618182,56.5796622 100.252333,55.7059281 99.8778754,54.8192817 C98.8255208,52.340115 97.6892361,49.8803168 96.5077582,47.4592556 C115.262912,39.8087023 123.778592,28.8913303 124.882595,27.4386936 Z M85.5,8.75455729 C97.9252191,8.74248437 109.920697,13.301685 119.201172,21.5635851 C118.284397,22.8548177 110.640299,33.1459418 92.5630425,39.918457 C86.896858,29.6009803 80.5650384,19.6633016 73.6077474,10.168457 C77.5021589,9.22958337 81.4940139,8.75498171 85.5,8.75455729 Z M63.9105903,13.5837674 C70.7134463,23.0345258 77.0022527,32.8448915 82.7496745,42.9722222 C67.4163715,46.9937375 51.6391647,49.0759644 35.7875434,49.1701389 C39.0814925,33.5630123 49.4873268,20.3956665 63.9105903,13.5837674 Z M34.6964518,59.577474 C34.6964518,59.0609809 34.6964518,58.5380317 34.6964518,58.0215386 C36.917372,58.0667318 61.5476345,58.3830838 86.9268121,50.7906359 C88.3794488,53.6378038 89.77398,56.5301649 91.0458442,59.4160699 C90.3744032,59.6054507 89.7072663,59.8077438 89.0444336,60.0229492 C62.832411,68.4934353 48.8870985,91.5871311 47.7249891,93.5562609 C39.3199784,84.2367922 34.6767898,72.1272275 34.6964518,59.577474 Z M85.5,110.400391 C74.1941093,110.41188 63.2105273,106.634 54.3038194,99.6702474 C55.2205946,97.7979601 65.5052626,77.9194336 94.1706272,67.9317491 L94.5063477,67.8155382 C99.3312957,80.2890818 102.960886,93.1926091 105.346246,106.352376 C99.0717732,109.027129 92.3207986,110.404117 85.5,110.400391 Z M113.907118,101.710395 C111.658497,89.3730642 108.355904,77.2513161 104.035645,65.4784071 C119.962999,62.9282227 133.953505,67.0989041 135.670844,67.647678 C133.426523,81.5165958 125.550329,93.8414019 113.907118,101.703939 L113.907118,101.710395 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-1.3%",
    width: "102.5%",
    height: "102.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.134992074 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1048.000000, -264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dribbble-ball-mark",
    transform: "translate(1049.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#C70B53",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.023196,136.057442 C14.7190702,130.861826 17.8250982,126.73405 21.3412799,123.674115 C24.8574617,120.61418 28.8574581,118.250289 33.3412693,116.582441",
    id: "Path-5",
    stroke: "#C70B53",
    strokeWidth: 6,
    strokeLinecap: "round",
    transform: "translate(22.682233, 126.319942) rotate(-6.000000) translate(-22.682233, -126.319942) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02319599,124.057442 C3.71907018,118.861826 6.82509815,114.73405 10.3412799,111.674115 C13.8574617,108.61418 17.8574581,106.250289 22.3412693,104.582441",
    id: "Path-5",
    stroke: "#C70B53",
    strokeWidth: 6,
    strokeLinecap: "round",
    transform: "translate(11.682233, 114.319942) rotate(-6.000000) translate(-11.682233, -114.319942) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.3099048891e4482efde43e718a99f141.svg";
export { ForwardRef as ReactComponent };